// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"PutUpForAdoption_MainContainer__2pUgp","Back":"PutUpForAdoption_Back__3PgzE","Form":"PutUpForAdoption_Form__3mVmn"};